import { useNavigate } from "react-router-dom";
import CourseBlockInterface from "../Interfaces/CourseBlockInterface";
import { useEffect, useState } from "react";
import CourseListBlock from "../Components/Modules/CourseList/CourseListBlock";
import Collection from "../Api/ReadCollection";

const Account = () => {
  const [courseList, setCourseList] = useState<
    Array<CourseBlockInterface> | Record<string, any>[]
  >([]);
  const activeCourse = localStorage.getItem("active_course") || "";
  const myCourses =
    JSON.parse(localStorage.getItem("my_courses") || "[]") || [];
  const certificatList =
    JSON.parse(localStorage.getItem("certificat_completed") || "[]") || [];

  const fetchCourse: any = Collection.readCollection("Course") || [];

  async function fetchCourseList() {
    setCourseList(await fetchCourse);
  }

  useEffect(() => {
    fetchCourseList();
  }, []);

  return (
    <div className="coursesListPage">
      <div className="coursesListPage">
        <div className="accountInfo">
          <h2>Анкета</h2>
          <div>Электронная почта: {localStorage.getItem("email")}</div>
          <div>Возраст: {localStorage.getItem("age")}</div>
          <div>Пол: {localStorage.getItem("gender")}</div>
          <div>Сфера деятельности: {localStorage.getItem("activity")}</div>
          <div>Должность: {localStorage.getItem("position")}</div>
        </div>
        <div className="coursesList">
          <h2>Активные курсы</h2>
          <div className="coursesListContent">
            {courseList.map((item, index) => {
              if (myCourses.find((course: string) => course === item.id)) {
                return (
                  <CourseListBlock
                    key={index}
                    id={item.id}
                    title={item.title}
                    description={item.description}
                    course_details={item.course_details}
                    duration={item.duration}
                    hours={item.hours}
                    document_name={item.document_name}
                    course_video={item.course_video}
                    access_type={item.access_type}
                    modules={item.modules}
                    track_list={item.track_list}
                    layout={item.layout}
                    background_color={item.background_color}
                    background_non_color={item.background_non_color}
                    price={item.price}
                    suitable={item.suitable}
                    test_certificat_id={item.test_certificat_id}
                    certificat_hours={item.certificat_hours}
                    status={
                      Number(activeCourse) === item.id
                        ? "ИЗУЧАЮ"
                        : certificatList.find(
                            (course: string) => course === item.id
                          )
                        ? "СЕРТИФИКАТ ПОЛУЧЕН"
                        : "ДОСТУПЕН К ИЗУЧЕНИЮ"
                    }
                  />
                );
              }
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Account;
